(async () => {
    const syncCartAddOns = async () => {
        let cart
        cart = await fetch('/cart.json').then((res) => res.json())
        document.addEventListener('on:cart-drawer:before-open', async (event) => {
            cart = await fetch('/cart.json').then((res) => res.json())
        });
        document.addEventListener('on:line-item:change', async (event) => {
            const updatedCart = event.detail?.cart
            if (!updatedCart || !cart) return

            const itemsAdded = updatedCart.items_added.map((item) => item.view_key)
            const itemsRemoved = updatedCart.items_removed.map((item) => item.view_key)
            const updatedItems = [...itemsAdded, ...itemsRemoved]
            updatedItems.forEach((item) => {
                const parentLineItem = cart.items.find((lineItem) => lineItem.key === item)                
                if (!parentLineItem) return
                const lineItemProp = parentLineItem.properties?.Bundle
                if (!lineItemProp) return
                let parentLineItemQty = parentLineItem.quantity
                const lineItemAdded = updatedCart.items_added.find((lineItem) => lineItem.view_key === item)
                const lineItemRemoved = updatedCart.items_removed.find((lineItem) => lineItem.view_key === item)
                if (lineItemAdded) {
                    parentLineItemQty = parentLineItemQty + lineItemAdded.quantity
                }
                if (lineItemRemoved) {
                    parentLineItemQty = parentLineItemQty - lineItemRemoved.quantity
                }
                
                const allLineItemsToUpdate = updatedCart.items.filter((lineItem) => lineItem.properties?.Bundle === lineItemProp)
                if (!allLineItemsToUpdate) return
                const updates = {}
                allLineItemsToUpdate.forEach((item) => {
                    updates[item.key] = parentLineItemQty
                })
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({updates})
                })
                .then(res => res.json())
                .then(cartData => {
                    cart = cartData
                    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {bubbles: true}))
                    if (window.location.pathname === '/cart') {
                        window.setTimeout(() => {
                            fetch('/cart')
                                .then(res => res.text())
                                .then((html) => {
                                    const parser = new DOMParser();
                                    const doc = parser.parseFromString(html, 'text/html');
                                    const cartElUpdated = doc.querySelector('.cart__items cart-items');
                                    const cartEl = document.querySelector('.cart__items cart-items');
                                    if (cartElUpdated && cartEl) {
                                        cartEl.innerHTML = cartElUpdated.innerHTML
                                    }
                                })
                        }, 200)
                    }
                })

            })
        })
    }
    const removeOrphanedAddOns = async () => {
        const cart = await fetch('/cart.json').then((res) => res.json())
        const cartItems = cart.items
        const cartAddOns = cartItems?.filter((item) => item.properties?.Bundle && item.title.indexOf('Add-on:') !== -1)
        if (!cartAddOns) return
        const updates = {}
        cartAddOns.forEach((item) => {
            const parentLineItem = cartItems.find((lineItem) => lineItem.properties?.Bundle === item.properties?.Bundle && lineItem.title.indexOf('Add-on:') === -1)
            if (!parentLineItem) {
                updates[item.key] = 0
            }
        })
        if (Object.keys(updates).length > 0) {
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({updates})
            })
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {bubbles: true}))
            if (window.location.pathname === '/cart') {
                window.setTimeout(() => {
                    fetch('/cart')
                        .then(res => res.text())
                        .then((html) => {
                            const parser = new DOMParser();
                            const doc = parser.parseFromString(html, 'text/html');
                            const cartElUpdated = doc.querySelector('.cart__items cart-items');
                            const cartEl = document.querySelector('.cart__items cart-items');
                            if (cartElUpdated && cartEl) {
                                cartEl.innerHTML = cartElUpdated.innerHTML
                            }
                        })
                }, 200)
            }
        }

    }
    await removeOrphanedAddOns()
    syncCartAddOns()

})();
